var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 22.5V0H0v22.5h12.924l-1.406 5.625H7.562V30h16.875v-1.875h-3.955L19.076 22.5H32zM1.875 1.875h28.25v18.75H1.875V1.875zm16.674 26.25h-5.098l1.406-5.625h2.286l1.406 5.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7 9.214 1.327-1.326L11.7 6.563l1.326-1.326L11.7 3.91l-1.326 1.326L9.049 3.91 7.723 5.237 9.05 6.562 7.723 7.889 9.05 9.214l1.326-1.326zM22.95 3.91l-1.325 1.327-1.326-1.326-1.326 1.326L20.3 6.562l-1.326 1.326L20.3 9.214l1.326-1.326 1.326 1.326 1.326-1.326-1.326-1.325 1.326-1.326zM16 11.25a6.57 6.57 0 0 0-6.563 6.563v.937h1.876v-.938A4.693 4.693 0 0 1 16 13.125a4.693 4.693 0 0 1 4.688 4.688v.937h1.875v-.938A6.57 6.57 0 0 0 16 11.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ca92d0b25752e16074ae4d7179b9507c.svg";
export { ForwardRef as ReactComponent };